import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaBoxOpen } from "react-icons/fa";
export default function ModernBreadcrumb() {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);
    const formatBreadcrumb = (str) => {
        if (!str) return "";
        return str
            .replace(/[-_]/g, " ")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };
    return (
        <nav className="breadcrumb-container" aria-label="breadcrumb">
            <ul className="breadcrumb-list">
                <li>
                    <Link to="/" className="breadcrumb-link">
                        <FaHome className="breadcrumb-icon" /> Home
                    </Link>
                </li>
                {pathnames.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
                    const isLast = index === pathnames.length - 1;
                    return (
                        <li key={routeTo} className={isLast ? "active" : ""}>
                            <span className="separator">›</span>
                            {isLast ? (
                                <span className="breadcrumb-current">
                                    <FaBoxOpen className="breadcrumb-icon" /> {formatBreadcrumb(name)}
                                </span>
                            ) : (
                                <Link to={routeTo} className="breadcrumb-link">
                                    <FaBoxOpen className="breadcrumb-icon" /> {formatBreadcrumb(name)}
                                </Link>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}